<template>
  <div>
    <mt-header title="绑定姓名">
      <!-- <router-link to="/" slot="left">返回</router-link> -->
    </mt-header>

    <div class="wrap">
      <p class="tips">检测到账号还没有输入姓名，请输入您的真实姓名</p>
      <input class="ipt" placeholder="请输入您的真实姓名" v-model="userName" type="text" />
      <div @click="bind" class="btn">确认</div>
    </div>
  </div>
</template>
<script>
import { isEmpty, cacheGet, cacheSet } from "@/utils/util.js";
import { reName } from "@/api/api.js";
import { Toast } from "mint-ui";
export default {
  data() {
    return {
      userName: "",
    };
  },
  methods: {
    bind() {
      if (this.checkBind()) {
        let token = cacheGet("token");
        reName({
          username: this.userName,
        }).then((res) => {
          Toast("绑定成功");
          cacheSet("username", this.userName);
          setTimeout(() => {
            this.$router.replace("/");
          }, 200);
        });
      }
    },
    checkBind() {
      if (isEmpty(this.userName)) {
        Toast("请输入姓名");
        return false;
      }
      return true;
    },
  },
};
</script>
<style lang="less" scoped>
.wrap {
  padding: 20px;
  .tips {
    margin-top: 100px;
    font-size: 0.4rem;
  }
  .ipt {
    margin-top: 60px;
    height: 100px;
    border: 1px solid #ccc;
    font-size: 0.4rem;
    line-height: 50px;
    border-radius: 10px;
    width: 100%;
    padding-left: 20px;
  }
  .btn {
    margin-top: 100px;
    width: 100%;
    height: 80px;
    background: #006feb;
    border-radius: 10px;
    text-align: center;
    font-size: 0.35rem;
    color: #fff;
    line-height: 80px;
  }
}
</style>